import React from 'react'; // Removed useState, useEffect, useMemo
import DualRangeSlider from './DualRangeSlider';

// getDimensionBounds has been moved to App.js

function Filters({ 
  // tanks, // No longer directly needed if bounds are passed
  dimensionBounds, // PROP: Overall min/max for each dimension
  currentRanges,   // PROP: Current selected min/max for each dimension
  onCurrentRangesChange, // PROP: Callback to update currentRanges in App.js `(dimension, newRange) => void` -> actually, let's make it `(newRanges) => void` for simplicity
  onClosePanel,       // PROP: Callback to close this panel
  matchingTankCount   // PROP: Number of tanks matching current filters
}) {
  // Internal state for currentRanges and bounds is removed.
  // useEffects for applying filters and resetting ranges are removed (handled in App.js).

  const handleRangeSliderChange = (dimension, newRangeValues) => {
    const newCurrentRanges = {
      ...currentRanges,
      [dimension]: { min: newRangeValues[0], max: newRangeValues[1] },
    };
    onCurrentRangesChange(newCurrentRanges); // Update state in App.js
  };

  const renderFilterInput = (dimension, label) => {
    const boundsForDim = dimensionBounds[dimension];
    const currentRangeForDim = currentRanges[dimension];
    
    // Ensure a fallback if bounds/ranges are not yet initialized properly
    if (!boundsForDim || !currentRangeForDim) {
        return <div className="tw-p-3">Loading filter for {label}...</div>;
    }

    const step = boundsForDim.max > boundsForDim.min 
                 ? Math.max(1, Math.round((boundsForDim.max - boundsForDim.min) / 100)) 
                 : 1;

    return (
      <div className="tw-mb-0 tw-p-3 tw-border tw-border-gray-200">
        <label className="tw-block tw-text-center tw-font-medium tw-mb-2 tw-mt-2 tw-text-sm tw-capitalize">{label}</label>
        <DualRangeSlider
          min={boundsForDim.min}
          max={boundsForDim.max}
          step={step}
          value={[currentRangeForDim.min, currentRangeForDim.max]}
          onValueChange={(newValues) => handleRangeSliderChange(dimension, newValues)}
          aria-label={`${label} range slider`}
        />
      </div>
    );
  };

  // The collapsed state logic is removed (handled by App.js via isFilterPanelOpen).
  // The check for `!tanks || tanks.length === 0` might not be needed here if panel only shows when data exists.

  return (
    <div className="tw-bg-white tw-p-0 tw-rounded-lg tw-shadow-md tw-mb-4"> {/* Added margin-bottom */}
      <div className="tw-grid tw-grid-cols-1 tw-gap-0">
        {renderFilterInput('gallons', 'Gallons')}
        {renderFilterInput('length', 'Length (inches)')}
        {renderFilterInput('width', 'Width (inches)')}
        {renderFilterInput('height', 'Height (inches)')}
      </div>
      <div className="tw-mt-6 tw-text-center">
        <button 
          onClick={onClosePanel} // Use the new onClosePanel prop
          className="tw-px-10 tw-py-3 tw-mb-6 tw-bg-brand-red hover:tw-bg-brand-red-dark tw-text-xl tw-text-white tw-font-semibold tw-rounded-md tw-shadow-md focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-green-500 focus:tw-ring-opacity-50 transition-colors duration-200"
        >
          View {matchingTankCount} Tank{matchingTankCount !== 1 ? 's' : ''}
        </button>
      </div>
    </div>
  );
}

export default Filters; 